import React, { useEffect, useRef, useState } from "react";
import { ChevronRight } from "lucide-react";
import { partner } from "../mock";

function useInView(threshold = 0.2) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ob = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setInView(true);
          ob.disconnect();
        }
      },
      { threshold }
    );
    ob.observe(el);
    return () => ob.disconnect();
  }, [threshold]);
  return [ref, inView];
}

const PartnerSection = () => {
  const [ref, inView] = useInView(0.18);

  return (
    <section id="partner" className="bg-[#EDF1F8] py-24">
      <div
        ref={ref}
        className={`reveal ${inView ? "in" : ""} mx-auto grid max-w-[1180px] grid-cols-1 items-center gap-14 px-6 md:grid-cols-2 md:gap-20`}
      >
        {/* organic hand-painted ice + penguins illustration */}
        <div className="flex justify-center">
          <div className="relative w-full max-w-[440px]">
            <svg
              viewBox="0 0 520 700"
              className="relative w-full h-auto drop-shadow-[0_28px_54px_rgba(20,40,70,0.12)]"
              style={{ overflow: "visible" }}
            >
              <defs>
                <mask id="ppMask">
                  <path
                    d="M250,32 C366,18 462,122 462,276 C466,432 430,612 268,666 C118,672 70,498 56,330 C44,166 152,44 250,32 Z"
                    fill="#fff"
                  />
                </mask>
              </defs>
              <image
                href={partner.image}
                x="0"
                y="0"
                width="520"
                height="700"
                preserveAspectRatio="xMidYMid slice"
                mask="url(#ppMask)"
              />
            </svg>
          </div>
        </div>

        {/* text + bullets */}
        <div>
          <h2 className="font-serif text-[#16263F] leading-[1.02] tracking-tight">
            <span className="block text-[9vw] md:text-[3.8rem]">
              {partner.title1}
            </span>
            <span className="block text-[9vw] md:text-[3.8rem]">
              {partner.title2}
            </span>
          </h2>

          <p className="mt-8 max-w-lg text-[16px] leading-7 text-slate-400">
            {partner.description}
          </p>

          <ul className="mt-12 space-y-7">
            {partner.bullets.map((b) => (
              <li key={b} className="flex items-center gap-4">
                <span className="h-2.5 w-2.5 shrink-0 rounded-full bg-[#5BA4FB]" />
                <span className="text-[19px] font-semibold text-[#16263F]">
                  {b}
                </span>
              </li>
            ))}
          </ul>

          <button className="mt-14 inline-flex items-center gap-1.5 rounded-2xl bg-[#5BA4FB] px-10 py-4 text-[16px] font-semibold text-white shadow-[0_12px_30px_rgba(91,164,251,0.4)] transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#7AB5FC]">
            {partner.cta} <ChevronRight className="h-4 w-4" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default PartnerSection;
